<template>
  <div>
    <el-card>
      <alter-form labelWidth="210px" @handleChange="handleChange" ref="alterForm" @formSubmit="formSubmit" :modifyData="modifyData" :formData="formData" :collapseLength="collapseLength"></alter-form>
    </el-card>
  </div>
</template>

<script>
import onlineVoucherEdit from './index.js'
export default onlineVoucherEdit
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
